<template>
    <div class="disclaimer">
      <div class="message">
        <Message
          v-show="!conversation"
          :message="{msgLabelKey: `${retention ? 'start_disclaimer_retention' : 'start_disclaimer'}`}"
          :actions="disclaimerActions"
          :isIncoming="true"
          :type="'CHAT'"
        />
        <Message
          v-show="conversation && !typerActive"
          :message="{msgLabelKey: 'disagree_reply'}"
          :actions="areYouSureDisclaimerActions"
          :isIncoming="true"
          :type="'CHAT'"
        />
      </div>
    </div>
</template>

<script>
import Message from './Message'
import { mapState, mapActions } from 'vuex'
import { trigger, triggerType } from '@/helpers/Tracker'
let self
export default {
  components: { Message },
  name: 'Disclaimer',
  props: {
    retention: {
      type: Boolean,
      default: false
    }
  },
  created () {
    self = this
  },
  data () {
    return {
      linkAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      disclaimerActions: [{
        label: 'buttons_yes_agree',
        className: 'sanitas-button sanitas-primary',
        callback: function () {
          self.init({})
          trigger(triggerType.ACTION, 'ChatPrivacyProtectionEnabled')
        }
      }, {
        label: 'buttons_no_disagree',
        className: 'sanitas-button sanitas-tertiary',
        callback: function () {
          self.disagree()
          trigger(triggerType.ACTION, 'ChatPrivacyProtectionDisabled')
        }
      }],
      areYouSureDisclaimerActions: [{
        label: 'buttons_yes_agree',
        className: 'sanitas-button sanitas-primary',
        callback: function () {
          self.init({})
          trigger(triggerType.ACTION, 'ChatPrivacyProtectionEnabled')
        }
      }, {
        label: 'buttons_end_chat',
        className: 'sanitas-button sanitas-tertiary',
        callback: function () {
          self.resetAll()
        }
      }]
    }
  },
  methods: {
    ...mapActions('conversation', [
      'init',
      'disagree'
    ]),
    resetAll () {
      this.$emit('reset')
      this.$store.commit('uistate/SET_CONVERSATION_STATE', 'CONVERSATION_RATED', {root: true})
    }
  },
  computed: {
    ...mapState('uistate', ['restoringSession', 'conversationState']),
    ...mapState('conversation', ['conversation', 'typerActive'])
  }
}
</script>

<style scoped lang="postcss">
.disclaimer {
  .termsContainer {
    background-color: #3c3a38;
    padding: 8px;
    .terms {
      overflow: auto;
      overflow-x: hidden;
      height:140px;
      font-size: 12px;
      color: white;
      h3 {
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        font-weight: bold;
        color: var(--tw-c-original-green);
        margin-bottom: 8px;
      }
      >>> p {
        font-size: 12px;
        color: white;
        margin-bottom: 8px;
      }
      >>> a {
        font-size: 12px;
        word-break: break-all;
        &:hover {
          border: none;
        }
      }
    }
  }
}
</style>
